import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2331 2331"
      id="vector">
      <g
        id="group"
        transform="translate(523 116)">
        <path
          id="path"
          d="M 955.5 0 L 1009 0.5 L 955.5 1 L 955.5 0 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 285.5 1 L 620 1.5 L 285.5 2 L 285.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 1014.5 1 L 1021 1.5 L 1014.5 2 L 1014.5 1 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 234.5 2 L 240 2.5 L 234.5 3 L 234.5 2 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 1026.5 2 L 1030 2.5 L 1026.5 3 L 1026.5 2 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 227.5 3 L 230 3.5 L 227.5 4 L 227.5 3 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 1033.5 3 L 1036 3.5 L 1033.5 4 L 1033.5 3 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 166.5 24 L 165.5 26 L 166.5 24 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 161.5 27 L 160.5 29 L 161.5 27 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1099.5 28 L 1100.5 30 L 1099.5 28 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 158.5 29 L 157.5 31 L 158.5 29 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 1102.5 30 L 1103.5 32 L 1102.5 30 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 155.5 31 L 154.5 33 L 155.5 31 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 1105.5 32 L 1106.5 34 L 1105.5 32 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 152.5 33 L 151.5 35 L 152.5 33 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1109.5 35 L 1110.5 37 L 1109.5 35 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 148.5 36 L 147.5 38 L 148.5 36 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 1113.5 38 L 1115.5 41 L 1113.5 38 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 144.5 39 L 141.5 43 L 144.5 39 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1118.5 42 L 1124.5 49 L 1118.5 42 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 138.5 44 L 122.5 61 L 138.5 44 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 1131.5 55 L 1137.5 62 L 1131.5 55 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 119.5 64 L 117.5 67 L 119.5 64 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1139.5 64 L 1141.5 67 L 1139.5 64 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 115.5 69 L 113.5 72 L 115.5 69 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1143.5 69 L 1144.5 71 L 1143.5 69 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 1002.5 70 L 1009 70.5 L 1002.5 71 L 1002.5 70 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 278.5 71 L 613 71.5 L 278.5 72 L 278.5 71 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 991.5 71 L 995 71.5 L 991.5 72 L 991.5 71 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 1016.5 71 L 1020 71.5 L 1016.5 72 L 1016.5 71 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 239.5 72 L 243 72.5 L 239.5 73 L 239.5 72 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 985.5 72 L 988 72.5 L 985.5 73 L 985.5 72 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 1023.5 72 L 1026 72.5 L 1023.5 73 L 1023.5 72 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 112.5 73 L 111.5 75 L 112.5 73 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 233.5 73 L 236 73.5 L 233.5 74 L 233.5 73 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 1146.5 73 L 1147.5 75 L 1146.5 73 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 228.5 74 L 231 74.5 L 228.5 75 L 228.5 74 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 1152.5 82 L 1153.5 84 L 1152.5 82 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 104.5 85 L 103.5 87 L 104.5 85 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 199.5 86 L 198.5 88 L 199.5 86 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 1060.5 86 L 1061.5 88 L 1060.5 86 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 1155.5 87 L 1156.5 89 L 1155.5 87 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 1063.5 88 L 1064.5 90 L 1063.5 88 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 193.5 90 L 192.5 92 L 193.5 90 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 1067.5 91 L 1068.5 93 L 1067.5 91 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 190.5 92 L 188.5 95 L 190.5 92 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 1071.5 94 L 1076.5 100 L 1071.5 94 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 185.5 96 L 173.5 109 L 185.5 96 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 1080.5 103 L 1085.5 109 L 1080.5 103 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 171.5 111 L 170.5 113 L 171.5 111 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 1087.5 111 L 1088.5 113 L 1087.5 111 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 168.5 115 L 167.5 117 L 168.5 115 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 166.5 118 L 165.5 120 L 166.5 118 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 82.5 140 L 83 142.5 L 82 142.5 L 82.5 140 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 1176.5 144 L 1177 146.5 L 1176 146.5 L 1176.5 144 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 81.5 145 L 82 147.5 L 81 147.5 L 81.5 145 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 1177.5 150 L 1178 153.5 L 1177 153.5 L 1177.5 150 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 80.5 152 L 81 155.5 L 80 155.5 L 80.5 152 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 151.5 152 L 152 154.5 L 151 154.5 L 151.5 152 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 1107.5 156 L 1108 158.5 L 1107 158.5 L 1107.5 156 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 150.5 157 L 151 160.5 L 150 160.5 L 150.5 157 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 1178.5 159 L 1179 165.5 L 1178 165.5 L 1178.5 159 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 79.5 161 L 80 169.5 L 79 169.5 L 79.5 161 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 1108.5 163 L 1109 168.5 L 1108 168.5 L 1108.5 163 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 149.5 165 L 150 171.5 L 149 171.5 L 149.5 165 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 149.5 178 L 150 184.5 L 149 184.5 L 149.5 178 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 1108.5 180 L 1109 185.5 L 1108 185.5 L 1108.5 180 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 79.5 181 L 80 189.5 L 79 189.5 L 79.5 181 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 1178.5 182 L 1179 188.5 L 1178 188.5 L 1178.5 182 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 150.5 189 L 151 191.5 L 150 191.5 L 150.5 189 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1107.5 189 L 1108 191.5 L 1107 191.5 L 1107.5 189 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 1177.5 194 L 1178 197.5 L 1177 197.5 L 1177.5 194 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 80.5 195 L 81 198.5 L 80 198.5 L 80.5 195 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 1176.5 201 L 1177 203.5 L 1176 203.5 L 1176.5 201 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 81.5 202 L 82 204.5 L 81 204.5 L 81.5 202 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 1175.5 207 L 1176 209.5 L 1175 209.5 L 1175.5 207 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 82.5 208 L 83 210.5 L 82 210.5 L 82.5 208 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 161.5 223 L 162.5 225 L 161.5 223 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 1096.5 223 L 1095.5 225 L 1096.5 223 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 163.5 226 L 164.5 228 L 163.5 226 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 1089.5 234 L 1088.5 236 L 1089.5 234 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 1086.5 238 L 1084.5 241 L 1086.5 238 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 1082.5 243 L 1074.5 252 L 1082.5 243 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 1070.5 254 L 1068.5 257 L 1070.5 254 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 98.5 255 L 99.5 257 L 98.5 255 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 1066.5 257 L 1065.5 259 L 1066.5 257 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 105.5 267 L 106.5 269 L 105.5 267 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 1150.5 269 L 1149.5 271 L 1150.5 269 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 109.5 273 L 110.5 275 L 109.5 273 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 1145.5 276 L 1144.5 278 L 1145.5 276 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 110.5 277 L 109.5 279 L 110.5 277 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 108.5 280 L 107.5 282 L 108.5 280 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 1142.5 280 L 1141.5 282 L 1142.5 280 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 106.5 283 L 105.5 285 L 106.5 283 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 1139.5 284 L 1135.5 289 L 1139.5 284 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 103.5 288 L 102.5 290 L 103.5 288 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 198.5 288 L 197.5 290 L 198.5 288 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 973.5 289 L 976 289.5 L 973.5 290 L 973.5 289 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 195.5 290 L 194.5 292 L 195.5 290 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 967.5 290 L 970 290.5 L 967.5 291 L 967.5 290 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 192.5 292 L 191.5 294 L 192.5 292 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 1132.5 292 L 1123.5 302 L 1132.5 292 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 188.5 295 L 186.5 298 L 188.5 295 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 182.5 300 L 176.5 307 L 182.5 300 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 1119.5 304 L 1115.5 309 L 1119.5 304 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 173.5 310 L 171.5 313 L 173.5 310 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 1112.5 310 L 1111.5 312 L 1112.5 310 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 1108.5 313 L 1107.5 315 L 1108.5 313 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 169.5 315 L 168.5 317 L 169.5 315 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 1105.5 318 L 1106.5 320 L 1105.5 318 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 1109.5 321 L 1110.5 323 L 1109.5 321 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 1113.5 324 L 1115.5 327 L 1113.5 324 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 1118.5 328 L 1124.5 335 L 1118.5 328 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 1132.5 342 L 1138.5 349 L 1132.5 342 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 81.5 346 L 82 348.5 L 81 348.5 L 81.5 346 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 1140.5 351 L 1142.5 354 L 1140.5 351 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 80.5 352 L 81 355.5 L 80 355.5 L 80.5 352 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 999.5 356 L 1013 356.5 L 999.5 357 L 999.5 356 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 1144.5 356 L 1145.5 358 L 1144.5 356 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1018.5 357 L 1022 357.5 L 1018.5 358 L 1018.5 357 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 150.5 358 L 151 360.5 L 150 360.5 L 150.5 358 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 79.5 360 L 80 366.5 L 79 366.5 L 79.5 360 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 1149.5 363 L 1150.5 365 L 1149.5 363 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 149.5 364 L 150 368.5 L 149 368.5 L 149.5 364 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 1151.5 366 L 1152.5 368 L 1151.5 366 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 1059.5 371 L 1060.5 373 L 1059.5 371 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 1154.5 371 L 1155.5 373 L 1154.5 371 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 1062.5 373 L 1063.5 375 L 1062.5 373 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 1065.5 375 L 1066.5 377 L 1065.5 375 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 1069.5 378 L 1071.5 381 L 1069.5 378 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 1075.5 383 L 1082.5 391 L 1075.5 383 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 149.5 385 L 150 389.5 L 149 389.5 L 149.5 385 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 79.5 387 L 80 393.5 L 79 393.5 L 79.5 387 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 150.5 393 L 151 395.5 L 150 395.5 L 150.5 393 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 1085.5 394 L 1087.5 397 L 1085.5 394 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 80.5 398 L 81 401.5 L 80 401.5 L 80.5 398 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 151.5 398 L 152 400.5 L 151 400.5 L 151.5 398 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1088.5 398 L 1089.5 400 L 1088.5 398 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 1091.5 402 L 1092.5 404 L 1091.5 402 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 81.5 405 L 82 407.5 L 81 407.5 L 81.5 405 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 1094.5 407 L 1095.5 409 L 1094.5 407 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 83.5 415 L 84 417.5 L 83 417.5 L 83.5 415 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 1175.5 423 L 1176 425.5 L 1175 425.5 L 1175.5 423 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 1176.5 428 L 1177 430.5 L 1176 430.5 L 1176.5 428 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 1177.5 434 L 1178 437.5 L 1177 437.5 L 1177.5 434 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 168.5 437 L 169.5 439 L 168.5 437 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 171.5 441 L 173.5 444 L 171.5 441 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 1178.5 442 L 1179 447.5 L 1178 447.5 L 1178.5 442 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 176.5 447 L 181.5 453 L 176.5 447 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 1108.5 447 L 1109 450.5 L 1108 450.5 L 1108.5 447 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 97.5 455 L 98.5 457 L 97.5 455 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 185.5 455 L 188.5 459 L 185.5 455 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 191.5 460 L 192.5 462 L 191.5 460 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 194.5 462 L 195.5 464 L 194.5 462 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 102.5 464 L 103.5 466 L 102.5 464 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 1108.5 469 L 1109 472.5 L 1108 472.5 L 1108.5 469 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 1178.5 473 L 1179 477.5 L 1178 477.5 L 1178.5 473 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 110.5 476 L 111.5 478 L 110.5 476 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 112.5 479 L 114.5 482 L 112.5 479 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 236.5 479 L 240 479.5 L 236.5 480 L 236.5 479 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 245.5 480 L 260 480.5 L 245.5 481 L 245.5 480 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 115.5 483 L 118.5 487 L 115.5 483 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 1177.5 483 L 1178 485.5 L 1177 485.5 L 1177.5 483 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 120.5 489 L 127.5 497 L 120.5 489 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 1176.5 489 L 1177 491.5 L 1176 491.5 L 1176.5 489 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 131.5 500 L 138.5 508 L 131.5 500 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 142.5 510 L 144.5 513 L 142.5 510 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 1095.5 511 L 1094.5 513 L 1095.5 511 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 147.5 514 L 148.5 516 L 147.5 514 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 1092.5 516 L 1091.5 518 L 1092.5 516 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 151.5 517 L 152.5 519 L 151.5 517 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 150.5 522 L 149.5 524 L 150.5 522 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 1087.5 523 L 1085.5 526 L 1087.5 523 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 146.5 525 L 144.5 528 L 146.5 525 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 141.5 529 L 137.5 534 L 141.5 529 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 1082.5 529 L 1074.5 538 L 1082.5 529 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 133.5 536 L 126.5 544 L 133.5 536 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 1071.5 539 L 1069.5 542 L 1071.5 539 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 1066.5 543 L 1065.5 545 L 1066.5 543 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 1157.5 544 L 1156.5 546 L 1157.5 544 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 288.5 546 L 291 546.5 L 288.5 547 L 288.5 546 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 123.5 547 L 119.5 552 L 123.5 547 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 282.5 547 L 285 547.5 L 282.5 548 L 282.5 547 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 1060.5 547 L 1059.5 549 L 1060.5 547 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 117.5 554 L 115.5 557 L 117.5 554 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 113.5 559 L 112.5 561 L 113.5 559 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 1146.5 561 L 1145.5 563 L 1146.5 561 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 111.5 562 L 110.5 564 L 111.5 562 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 1144.5 564 L 1142.5 567 L 1144.5 564 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 1140.5 569 L 1138.5 572 L 1140.5 569 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 105.5 571 L 104.5 573 L 105.5 571 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 198.5 574 L 197.5 576 L 198.5 574 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 1135.5 575 L 1121.5 590 L 1135.5 575 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 102.5 576 L 101.5 578 L 102.5 576 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 192.5 578 L 191.5 580 L 192.5 578 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 188.5 581 L 186.5 584 L 188.5 581 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 182.5 586 L 177.5 592 L 182.5 586 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 1117.5 592 L 1115.5 595 L 1117.5 592 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 174.5 595 L 171.5 599 L 174.5 595 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 1112.5 596 L 1110.5 599 L 1112.5 596 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 1108.5 599 L 1107.5 601 L 1108.5 599 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 169.5 601 L 168.5 603 L 169.5 601 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 1104.5 602 L 1103.5 606 Q 1100 604 1104.5 602 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 167.5 604 L 166.5 606 L 167.5 604 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 165.5 607 L 164.5 609 L 165.5 607 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 1106.5 607 L 1107.5 609 L 1106.5 607 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 1109.5 609 L 1111.5 612 L 1109.5 609 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 1114.5 613 L 1116.5 616 L 1114.5 613 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 1120.5 618 L 1136.5 635 L 1120.5 618 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 83.5 623 L 84 625.5 L 83 625.5 L 83.5 623 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 81.5 633 L 82 635.5 L 81 635.5 L 81.5 633 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 1139.5 638 L 1141.5 641 L 1139.5 638 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 80.5 640 L 81 643.5 L 80 643.5 L 80.5 640 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 151.5 640 L 152 642.5 L 151 642.5 L 151.5 640 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 1143.5 643 L 1144.5 645 L 1143.5 643 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 997.5 644 L 1014 644.5 L 997.5 645 L 997.5 644 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 150.5 645 L 151 648.5 L 150 648.5 L 150.5 645 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 989.5 645 L 993 645.5 L 989.5 646 L 989.5 645 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 1018.5 645 L 1022 645.5 L 1018.5 646 L 1018.5 645 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 1146.5 647 L 1147.5 649 L 1146.5 647 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 79.5 649 L 80 657.5 L 79 657.5 L 79.5 649 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 1148.5 650 L 1149.5 652 L 1148.5 650 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 149.5 653 L 150 660.5 L 149 660.5 L 149.5 653 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 1152.5 656 L 1153.5 658 L 1152.5 656 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 1062.5 661 L 1063.5 663 L 1062.5 661 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 1155.5 661 L 1156.5 663 L 1155.5 661 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 1066.5 664 L 1067.5 666 L 1066.5 664 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 149.5 665 L 150 672.5 L 149 672.5 L 149.5 665 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 1070.5 667 L 1072.5 670 L 1070.5 667 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 79.5 668 L 80 676.5 L 79 676.5 L 79.5 668 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 1077.5 673 L 1079.5 676 L 1077.5 673 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 150.5 677 L 151 679.5 L 150 679.5 L 150.5 677 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 1083.5 680 L 1086.5 684 L 1083.5 680 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 80.5 682 L 81 685.5 L 80 685.5 L 80.5 682 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 1088.5 686 L 1089.5 688 L 1088.5 686 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 1090.5 689 L 1091.5 691 L 1090.5 689 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 81.5 690 L 82 692.5 L 81 692.5 L 81.5 690 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 1092.5 692 L 1093.5 694 L 1092.5 692 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 82.5 695 L 83 697.5 L 82 697.5 L 82.5 695 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 1096.5 699 L 1097.5 701 L 1096.5 699 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 1175.5 712 L 1176 714.5 L 1175 714.5 L 1175.5 712 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 165.5 718 L 166.5 720 L 165.5 718 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 167.5 721 L 168.5 723 L 167.5 721 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 169.5 724 L 171.5 727 L 169.5 724 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 1177.5 724 L 1178 727.5 L 1177 727.5 L 1177.5 724 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 173.5 729 L 185.5 742 L 173.5 729 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 1107.5 730 L 1108 732.5 L 1107 732.5 L 1107.5 730 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 1178.5 733 L 1179 739.5 L 1178 739.5 L 1178.5 733 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 1108.5 736 L 1109 741.5 L 1108 741.5 L 1108.5 736 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 189.5 744 L 190.5 746 L 189.5 744 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 103.5 751 L 104.5 753 L 103.5 751 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 1108.5 754 L 1109 758.5 L 1108 758.5 L 1108.5 754 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 1178.5 755 L 1179 762.5 L 1178 762.5 L 1178.5 755 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 109.5 760 L 110.5 762 L 109.5 760 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 111.5 763 L 112.5 765 L 111.5 763 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 275.5 763 L 278 763.5 L 275.5 764 L 275.5 763 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 1107.5 763 L 1108 765.5 L 1107 765.5 L 1107.5 763 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 232.5 764 L 235 764.5 L 232.5 765 L 232.5 764 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 270.5 764 L 273 764.5 L 270.5 765 L 270.5 764 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 238.5 765 L 242 765.5 L 238.5 766 L 238.5 765 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 263.5 765 L 267 765.5 L 263.5 766 L 263.5 765 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 249.5 766 L 257 766.5 L 249.5 767 L 249.5 766 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 114.5 767 L 116.5 770 L 114.5 767 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 1177.5 768 L 1178 771.5 L 1177 771.5 L 1177.5 768 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 118.5 772 L 121.5 776 L 118.5 772 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 1176.5 775 L 1177 777.5 L 1176 777.5 L 1176.5 775 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 124.5 779 L 134.5 790 L 124.5 779 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 138.5 792 L 141.5 796 L 138.5 792 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 144.5 797 L 146.5 800 L 144.5 797 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 149.5 801 L 150.5 803 L 149.5 801 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 1091.5 805 L 1090.5 807 L 1091.5 805 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 154.5 807 L 153.5 809 L 154.5 807 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 1089.5 808 L 1087.5 811 L 1089.5 808 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 151.5 809 L 150.5 811 L 151.5 809 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 147.5 812 L 145.5 815 L 147.5 812 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 1086.5 812 L 1083.5 816 L 1086.5 812 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 142.5 816 L 140.5 819 L 142.5 816 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 136.5 821 L 123.5 835 L 136.5 821 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 1072.5 826 L 1070.5 829 L 1072.5 826 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 1067.5 830 L 1066.5 832 L 1067.5 830 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 1063.5 833 L 1062.5 835 L 1063.5 833 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 120.5 838 L 118.5 841 L 120.5 838 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 1153.5 838 L 1152.5 840 L 1153.5 838 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 1151.5 841 L 1150.5 843 L 1151.5 841 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 116.5 843 L 114.5 846 L 116.5 843 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 1149.5 844 L 1148.5 846 L 1149.5 844 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 1147.5 847 L 1146.5 849 L 1147.5 847 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 112.5 848 L 111.5 850 L 112.5 848 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 110.5 851 L 109.5 853 L 110.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 1144.5 851 L 1143.5 853 L 1144.5 851 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 108.5 854 L 107.5 856 L 108.5 854 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 1141.5 855 L 1139.5 858 L 1141.5 855 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 106.5 857 L 105.5 859 L 106.5 857 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 201.5 860 L 200.5 862 L 201.5 860 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 1137.5 860 L 1133.5 865 L 1137.5 860 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 196.5 863 L 195.5 865 L 196.5 863 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 971.5 863 L 974 863.5 L 971.5 864 L 971.5 863 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 966.5 864 L 969 864.5 L 966.5 865 L 966.5 864 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 193.5 865 L 192.5 867 L 193.5 865 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 189.5 868 L 187.5 871 L 189.5 868 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 99.5 869 L 98.5 871 L 99.5 869 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 184.5 872 L 174.5 883 L 184.5 872 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 1121.5 876 L 1117.5 881 L 1121.5 876 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 1114.5 882 L 1112.5 885 L 1114.5 882 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 172.5 885 L 170.5 888 L 172.5 885 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 1109.5 886 L 1108.5 888 L 1109.5 886 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 1105.5 889 L 1105 890.5 L 1106 892.5 L 1104 891.5 L 1105.5 889 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 168.5 890 L 167.5 892 L 168.5 890 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 166.5 893 L 165.5 895 L 166.5 893 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 1108.5 894 L 1109.5 896 L 1108.5 894 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 1112.5 897 L 1114.5 900 L 1112.5 897 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 163.5 898 L 162.5 900 L 163.5 898 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 1117.5 901 L 1120.5 905 L 1117.5 901 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 1125.5 908 L 1132.5 916 L 1125.5 908 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 83.5 910 L 84 912.5 L 83 912.5 L 83.5 910 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 1135.5 919 L 1139.5 924 L 1135.5 919 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 81.5 920 L 82 922.5 L 81 922.5 L 81.5 920 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 80.5 926 L 81 929.5 L 80 929.5 L 80.5 926 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 1141.5 926 L 1143.5 929 L 1141.5 926 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 996.5 930 L 1003 930.5 L 996.5 931 L 996.5 930 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 1009.5 930 L 1016 930.5 L 1009.5 931 L 1009.5 930 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 1020.5 931 L 1023 931.5 L 1020.5 932 L 1020.5 931 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 1145.5 931 L 1146.5 933 L 1145.5 931 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 150.5 932 L 151 934.5 L 150 934.5 L 150.5 932 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 79.5 934 L 80 940.5 L 79 940.5 L 79.5 934 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 1147.5 934 L 1148.5 936 L 1147.5 934 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 149.5 938 L 150 942.5 L 149 942.5 L 149.5 938 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 1056.5 943 L 1057.5 945 L 1056.5 943 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 1153.5 943 L 1154.5 945 L 1153.5 943 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 1061.5 946 L 1062.5 948 L 1061.5 946 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 1064.5 948 L 1065.5 950 L 1064.5 948 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 1156.5 948 L 1157.5 950 L 1156.5 948 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 1068.5 951 L 1070.5 954 L 1068.5 951 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 1073.5 955 L 1083.5 966 L 1073.5 955 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 149.5 958 L 150 962.5 L 149 962.5 L 149.5 958 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 79.5 961 L 80 966.5 L 79 966.5 L 79.5 961 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 150.5 967 L 151 969.5 L 150 969.5 L 150.5 967 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 1086.5 969 L 1087.5 971 L 1086.5 969 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 80.5 972 L 81 975.5 L 80 975.5 L 80.5 972 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 1089.5 973 L 1090.5 975 L 1089.5 973 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 1091.5 976 L 1092.5 978 L 1091.5 976 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 81.5 979 L 82 981.5 L 81 981.5 L 81.5 979 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 82.5 984 L 83 986.5 L 82 986.5 L 82.5 984 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 1175.5 997 L 1176 999.5 L 1175 999.5 L 1175.5 997 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 1176.5 1002 L 1177 1004.5 L 1176 1004.5 L 1176.5 1002 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 166.5 1008 L 167.5 1010 L 166.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 1177.5 1008 L 1178 1011.5 L 1177 1011.5 L 1177.5 1008 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 169.5 1012 L 170.5 1014 L 169.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 172.5 1016 L 176.5 1021 L 172.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 1178.5 1016 L 1179 1021.5 L 1178 1021.5 L 1178.5 1016 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 1108.5 1021 L 1109 1024.5 L 1108 1024.5 L 1108.5 1021 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 182.5 1026 L 186.5 1031 L 182.5 1026 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 189.5 1032 L 190.5 1034 L 189.5 1032 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 193.5 1035 L 194.5 1037 L 193.5 1035 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 196.5 1037 L 197.5 1039 L 196.5 1037 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 1108.5 1042 L 1109 1046.5 L 1108 1046.5 L 1108.5 1042 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 1178.5 1046 L 1179 1051.5 L 1178 1051.5 L 1178.5 1046 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 110.5 1050 L 111.5 1052 L 110.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 1107.5 1050 L 1108 1052.5 L 1107 1052.5 L 1107.5 1050 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 232.5 1052 L 235 1052.5 L 232.5 1053 L 232.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 112.5 1053 L 114.5 1056 L 112.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 238.5 1053 L 242 1053.5 L 238.5 1054 L 238.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 262.5 1053 L 265 1053.5 L 262.5 1054 L 262.5 1053 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 1177.5 1056 L 1178 1058.5 L 1177 1058.5 L 1177.5 1056 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 116.5 1058 L 118.5 1061 L 116.5 1058 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 120.5 1063 L 125.5 1069 L 120.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 133.5 1076 L 139.5 1083 L 133.5 1076 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 1096.5 1083 L 1095.5 1085 L 1096.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 142.5 1084 L 144.5 1087 L 142.5 1084 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 147.5 1088 L 149 1090.5 L 148 1090.5 L 147.5 1088 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 1093.5 1088 L 1092.5 1090 L 1093.5 1088 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 145.5 1092 L 143.5 1095 L 145.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 1089.5 1094 L 1088.5 1096 L 1089.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 140.5 1096 L 135.5 1102 L 140.5 1096 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 1086.5 1098 L 1083.5 1102 L 1086.5 1098 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 1080.5 1105 L 1076.5 1110 L 1080.5 1105 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 125.5 1111 L 120.5 1117 L 125.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 1072.5 1112 L 1070.5 1115 L 1072.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 1067.5 1116 L 1066.5 1118 L 1067.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 118.5 1119 L 116.5 1122 L 118.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 1159.5 1120 L 1161.5 1123 L 1159.5 1120 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 281.5 1121 L 284 1121.5 L 281.5 1122 L 281.5 1121 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 1058.5 1122 L 1057.5 1124 L 1058.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 114.5 1124 L 113.5 1126 L 114.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 1163.5 1125 L 1164.5 1127 L 1163.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 111.5 1128 L 110.5 1130 L 111.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 1165.5 1128 L 1166.5 1130 L 1165.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 109.5 1131 L 108.5 1133 L 109.5 1131 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 107.5 1134 L 106.5 1136 L 107.5 1134 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 105.5 1137 L 104.5 1139 L 105.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 1171.5 1137 L 1172.5 1139 L 1171.5 1137 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 102.5 1142 L 101.5 1144 L 102.5 1142 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 1175.5 1144 L 1176.5 1146 L 1175.5 1144 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 196.5 1149 L 195.5 1151 L 196.5 1149 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 193.5 1151 L 192.5 1153 L 193.5 1151 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 189.5 1154 L 187.5 1157 L 189.5 1154 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 183.5 1159 L 176.5 1167 L 183.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 174.5 1169 L 171.5 1173 L 174.5 1169 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 1108.5 1173 L 1107.5 1175 L 1108.5 1173 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 170.5 1174 L 169.5 1176 L 170.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 1096.5 1181 L 1095.5 1183 L 1096.5 1181 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 164.5 1183 L 163.5 1185 L 164.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 1091.5 1184 L 1090.5 1186 L 1091.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 83.5 1189 L 84 1191.5 L 83 1191.5 L 83.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 1194.5 1197 L 1195 1199.5 L 1194 1199.5 L 1194.5 1197 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 81.5 1199 L 82 1201.5 L 81 1201.5 L 81.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 1195.5 1203 L 1196 1206.5 L 1195 1206.5 L 1195.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 80.5 1206 L 81 1209.5 L 80 1209.5 L 80.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 1125.5 1209 L 1126 1211.5 L 1125 1211.5 L 1125.5 1209 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 1196.5 1212 L 1197 1218.5 L 1196 1218.5 L 1196.5 1212 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 79.5 1215 L 80 1223.5 L 79 1223.5 L 79.5 1215 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 151.5 1216 L 152 1218.5 L 151 1218.5 L 151.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 1126.5 1216 L 1127 1220.5 L 1126 1220.5 L 1126.5 1216 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 150.5 1222 L 151 1225.5 L 150 1225.5 L 150.5 1222 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 79.5 1231 L 80 1249.5 L 79 1249.5 L 79.5 1231 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 1126.5 1235 L 1127 1239.5 L 1126 1239.5 L 1126.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 1196.5 1237 L 1197 1243.5 L 1196 1243.5 L 1196.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 150.5 1241 L 151 1244.5 L 150 1244.5 L 150.5 1241 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 1125.5 1244 L 1126 1246.5 L 1125 1246.5 L 1125.5 1244 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 1195.5 1249 L 1196 1252.5 L 1195 1252.5 L 1195.5 1249 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 80.5 1255 L 81 1259.5 L 80 1259.5 L 80.5 1255 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 1194.5 1256 L 1195 1258.5 L 1194 1258.5 L 1194.5 1256 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 1193.5 1261 L 1194 1263.5 L 1193 1263.5 L 1193.5 1261 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 81.5 1263 L 82 1265.5 L 81 1265.5 L 81.5 1263 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 82.5 1269 L 83 1271.5 L 82 1271.5 L 82.5 1269 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 164.5 1282 L 165.5 1284 L 164.5 1282 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 1111.5 1282 L 1110.5 1284 L 1111.5 1282 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 166.5 1285 L 167.5 1287 L 166.5 1285 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 1109.5 1285 L 1108.5 1287 L 1109.5 1285 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 168.5 1288 L 169.5 1290 L 168.5 1288 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 1106.5 1289 L 1105.5 1291 L 1106.5 1289 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 171.5 1292 L 173.5 1295 L 171.5 1292 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 1103.5 1293 L 1099.5 1298 L 1103.5 1293 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 176.5 1298 L 182.5 1305 L 176.5 1298 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 1093.5 1303 L 1089.5 1308 L 1093.5 1303 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 186.5 1307 L 188.5 1310 L 186.5 1307 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 1086.5 1309 L 1085.5 1311 L 1086.5 1309 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 191.5 1311 L 192.5 1313 L 191.5 1311 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 1082.5 1312 L 1081.5 1314 L 1082.5 1312 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 1174.5 1313 L 1173.5 1315 L 1174.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 1171.5 1318 L 1170.5 1320 L 1171.5 1318 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 1167.5 1324 L 1166.5 1326 L 1167.5 1324 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 582.5 1327 L 584.5 1328 L 1047 1328.5 L 581.5 1329 L 582.5 1327 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 225.5 1328 L 310 1328.5 L 225.5 1329 L 225.5 1328 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 1168.5 1329 L 1172 1329.5 L 1168.5 1330 L 1168.5 1329 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 62.5 1347 L 61.5 1349 L 62.5 1347 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 1222.5 1347 L 1223.5 1349 L 1222.5 1347 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 59.5 1349 L 58.5 1351 L 59.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 1225.5 1349 L 1226.5 1351 L 1225.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 56.5 1351 L 55.5 1353 L 56.5 1351 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 1228.5 1351 L 1229.5 1353 L 1228.5 1351 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 52.5 1354 L 51.5 1356 L 52.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 1232.5 1354 L 1233.5 1356 L 1232.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 48.5 1357 L 46.5 1360 L 48.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1236.5 1357 L 1239.5 1361 L 1236.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 42.5 1362 L 34.5 1371 L 42.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 1242.5 1362 L 1250.5 1371 L 1242.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 31.5 1374 L 28.5 1378 L 31.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 1253.5 1374 L 1256.5 1378 L 1253.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 1257.5 1379 L 1259.5 1382 L 1257.5 1379 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 26.5 1380 L 25.5 1382 L 26.5 1380 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 24.5 1383 L 23.5 1385 L 24.5 1383 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 1260.5 1383 L 1261.5 1385 L 1260.5 1383 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 129.5 1421 L 1156 1421.5 L 129.5 1422 L 129.5 1421 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 122.5 1422 L 125 1422.5 L 122.5 1423 L 122.5 1422 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1160.5 1422 L 1163 1422.5 L 1160.5 1423 L 1160.5 1422 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 109.5 1428 L 108.5 1430 L 109.5 1428 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 105.5 1431 L 102.5 1435 L 105.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 1179.5 1431 L 1182.5 1435 L 1179.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 2.5 1433 L 3 1435.5 L 2 1435.5 L 2.5 1433 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 1282.5 1433 L 1283 1435.5 L 1282 1435.5 L 1282.5 1433 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 1.5 1439 L 2 1441.5 L 1 1441.5 L 1.5 1439 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 1283.5 1439 L 1284 1442.5 L 1283 1442.5 L 1283.5 1439 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 0.5 1447 L 1 1456.5 L 0 1456.5 L 0.5 1447 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 1284.5 1447 L 1285 1559.5 L 1284 1559.5 L 1284.5 1447 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 93.5 1456 L 94 1551.5 L 93 1551.5 L 93.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 1191.5 1456 L 1192 1550.5 L 1191 1550.5 L 1191.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 0.5 1549 L 1 1560.5 L 0 1560.5 L 0.5 1549 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 1190.5 1557 L 1191 1560.5 L 1190 1560.5 L 1190.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 94.5 1558 L 95 1560.5 L 94 1560.5 L 94.5 1558 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 95.5 1564 L 96 1566.5 L 95 1566.5 L 95.5 1564 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1189.5 1564 L 1190 1566.5 L 1189 1566.5 L 1189.5 1564 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 1.5 1566 L 2 1570.5 L 1 1570.5 L 1.5 1566 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 1283.5 1566 L 1284 1569.5 L 1283 1569.5 L 1283.5 1566 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1282.5 1574 L 1283 1577.5 L 1282 1577.5 L 1282.5 1574 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 2.5 1575 L 3 1577.5 L 2 1577.5 L 2.5 1575 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 1281.5 1580 L 1282 1582.5 L 1281 1582.5 L 1281.5 1580 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 5.5 1590 L 6 1592.5 L 5 1592.5 L 5.5 1590 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 107.5 1597 L 108.5 1599 L 107.5 1597 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1177.5 1597 L 1176.5 1599 L 1177.5 1597 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 111.5 1603 L 112.5 1605 L 111.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 1173.5 1603 L 1172.5 1605 L 1173.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 113.5 1606 L 115.5 1609 L 113.5 1606 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 1171.5 1606 L 1169.5 1609 L 1171.5 1606 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 117.5 1611 L 129.5 1624 L 117.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 1167.5 1611 L 1155.5 1624 L 1167.5 1611 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 132.5 1625 L 133.5 1627 L 132.5 1625 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 1152.5 1625 L 1151.5 1627 L 1152.5 1625 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 136.5 1628 L 137.5 1630 L 136.5 1628 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 1148.5 1628 L 1147.5 1630 L 1148.5 1628 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 139.5 1630 L 140.5 1632 L 139.5 1630 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 1145.5 1630 L 1144.5 1632 L 1145.5 1630 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 144.5 1633 L 145.5 1635 L 144.5 1633 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 25.5 1642 L 26.5 1644 L 25.5 1642 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 1259.5 1642 L 1258.5 1644 L 1259.5 1642 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1106.5 1645 L 1109 1645.5 L 1106.5 1646 L 1106.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 182.5 1646 L 187 1646.5 L 182.5 1647 L 182.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 1098.5 1646 L 1103 1646.5 L 1098.5 1647 L 1098.5 1646 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 28.5 1647 L 29.5 1649 L 28.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 1256.5 1647 L 1255.5 1649 L 1256.5 1647 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 34.5 1656 L 35.5 1658 L 34.5 1656 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 1250.5 1656 L 1249.5 1658 L 1250.5 1656 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 36.5 1659 L 37.5 1661 L 36.5 1659 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 1248.5 1659 L 1247.5 1661 L 1248.5 1659 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 39.5 1663 L 40.5 1665 L 39.5 1663 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 1245.5 1663 L 1244.5 1665 L 1245.5 1663 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 42.5 1667 L 45.5 1671 L 42.5 1667 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 1242.5 1667 L 1239.5 1671 L 1242.5 1667 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 47.5 1673 L 53.5 1680 L 47.5 1673 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 1237.5 1673 L 1230.5 1681 L 1237.5 1673 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 60.5 1686 L 67.5 1694 L 60.5 1686 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1224.5 1686 L 1217.5 1694 L 1224.5 1686 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 70.5 1695 L 72.5 1698 L 70.5 1695 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 1214.5 1695 L 1212.5 1698 L 1214.5 1695 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 75.5 1699 L 77.5 1702 L 75.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1209.5 1699 L 1207.5 1702 L 1209.5 1699 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 79.5 1702 L 80.5 1704 L 79.5 1702 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 1205.5 1702 L 1204.5 1704 L 1205.5 1702 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 83.5 1705 L 84.5 1707 L 83.5 1705 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1201.5 1705 L 1200.5 1707 L 1201.5 1705 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 86.5 1707 L 87.5 1709 L 86.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 1198.5 1707 L 1197.5 1709 L 1198.5 1707 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 89.5 1709 L 90.5 1711 L 89.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 1195.5 1709 L 1194.5 1711 L 1195.5 1709 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 99.5 1715 L 100.5 1717 L 99.5 1715 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 1185.5 1715 L 1184.5 1717 L 1185.5 1715 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 1133.5 1735 L 1136 1735.5 L 1133.5 1736 L 1133.5 1735 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 159.5 1737 L 162 1737.5 L 159.5 1738 L 159.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 1123.5 1737 L 1126 1737.5 L 1123.5 1738 L 1123.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 165.5 1738 L 169 1738.5 L 165.5 1739 L 165.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 1117.5 1738 L 1120 1738.5 L 1117.5 1739 L 1117.5 1738 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 173.5 1739 L 178 1739.5 L 173.5 1740 L 173.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 1107.5 1739 L 1113 1739.5 L 1107.5 1740 L 1107.5 1739 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 186.5 1740 L 215 1740.5 L 186.5 1741 L 186.5 1740 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 1085.5 1740 L 1100 1740.5 L 1085.5 1741 L 1085.5 1740 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 1070.5 1741 L 1075 1741.5 L 1070.5 1742 L 1070.5 1741 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 308.5 1745 L 309 1754.5 L 308 1754.5 L 308.5 1745 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 976.5 1746 L 977 1754.5 L 976 1754.5 L 976.5 1746 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 215.5 1756 L 216 1762.5 L 215 1762.5 L 215.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 1069.5 1756 L 1070 1762.5 L 1069 1762.5 L 1069.5 1756 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 309.5 1760 L 310 1763.5 L 309 1763.5 L 309.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 975.5 1760 L 976 1763.5 L 975 1763.5 L 975.5 1760 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 310.5 1767 L 311 1769.5 L 310 1769.5 L 310.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 974.5 1767 L 975 1769.5 L 974 1769.5 L 974.5 1767 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 1068.5 1768 L 1069 1772.5 L 1068 1772.5 L 1068.5 1768 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 216.5 1769 L 217 1772.5 L 216 1772.5 L 216.5 1769 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 311.5 1772 L 312 1774.5 L 311 1774.5 L 311.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 217.5 1777 L 218 1779.5 L 217 1779.5 L 217.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 1067.5 1777 L 1068 1779.5 L 1067 1779.5 L 1067.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 218.5 1783 L 219 1785.5 L 218 1785.5 L 218.5 1783 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 1066.5 1783 L 1067 1785.5 L 1066 1785.5 L 1066.5 1783 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 219.5 1789 L 220 1791.5 L 219 1791.5 L 219.5 1789 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 338.5 1835 L 339.5 1837 L 338.5 1835 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 946.5 1835 L 945.5 1837 L 946.5 1835 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 341.5 1839 L 343.5 1842 L 341.5 1839 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 943.5 1839 L 941.5 1842 L 943.5 1839 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 345.5 1844 L 348.5 1848 L 345.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 939.5 1844 L 936.5 1848 L 939.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 351.5 1851 L 358.5 1859 L 351.5 1851 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 932.5 1852 L 926.5 1859 L 932.5 1852 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 363.5 1862 L 366.5 1866 L 363.5 1862 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 921.5 1862 L 918.5 1866 L 921.5 1862 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 369.5 1867 L 371.5 1870 L 369.5 1867 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 915.5 1867 L 913.5 1870 L 915.5 1867 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 374.5 1871 L 375.5 1873 L 374.5 1871 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 910.5 1871 L 909.5 1873 L 910.5 1871 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 251.5 1873 L 252.5 1875 L 251.5 1873 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 377.5 1873 L 378.5 1875 L 377.5 1873 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 907.5 1873 L 906.5 1875 L 907.5 1873 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 383.5 1877 L 384.5 1879 L 383.5 1877 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 901.5 1877 L 900.5 1879 L 901.5 1877 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 388.5 1880 L 389.5 1882 L 388.5 1880 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 896.5 1880 L 895.5 1882 L 896.5 1880 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 261.5 1888 L 262.5 1890 L 261.5 1888 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 1023.5 1888 L 1022.5 1890 L 1023.5 1888 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 264.5 1892 L 265.5 1894 L 264.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 1020.5 1892 L 1019.5 1894 L 1020.5 1892 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 636.5 1894 L 649 1894.5 L 636.5 1895 L 636.5 1894 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 266.5 1895 L 268.5 1898 L 266.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 622.5 1895 L 628 1895.5 L 622.5 1896 L 622.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 657.5 1895 L 663 1895.5 L 657.5 1896 L 657.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 1018.5 1895 L 1016.5 1898 L 1018.5 1895 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 615.5 1896 L 618 1896.5 L 615.5 1897 L 615.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 667.5 1896 L 670 1896.5 L 667.5 1897 L 667.5 1896 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 609.5 1897 L 612 1897.5 L 609.5 1898 L 609.5 1897 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 673.5 1897 L 676 1897.5 L 673.5 1898 L 673.5 1897 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 604.5 1898 L 607 1898.5 L 604.5 1899 L 604.5 1898 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 678.5 1898 L 681 1898.5 L 678.5 1899 L 678.5 1898 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 270.5 1900 L 272.5 1903 L 270.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 442.5 1900 L 445 1900.5 L 442.5 1901 L 442.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 840.5 1900 L 843 1900.5 L 840.5 1901 L 840.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 1014.5 1900 L 1012.5 1903 L 1014.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 448.5 1901 L 453 1901.5 L 448.5 1902 L 448.5 1901 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 832.5 1901 L 836 1901.5 L 832.5 1902 L 832.5 1901 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 459.5 1902 L 591 1902.5 L 459.5 1903 L 459.5 1902 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 694.5 1902 L 826 1902.5 L 694.5 1903 L 694.5 1902 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 274.5 1905 L 278.5 1910 L 274.5 1905 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 1010.5 1905 L 1006.5 1910 L 1010.5 1905 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 281.5 1913 L 297.5 1930 L 281.5 1913 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 1003.5 1913 L 988.5 1929 L 1003.5 1913 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 301.5 1932 L 305.5 1937 L 301.5 1932 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 983.5 1932 L 980.5 1936 L 983.5 1932 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 308.5 1938 L 310.5 1941 L 308.5 1938 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 976.5 1938 L 974.5 1941 L 976.5 1938 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 313.5 1942 L 314.5 1944 L 313.5 1942 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 971.5 1942 L 970.5 1944 L 971.5 1942 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 317.5 1945 L 318.5 1947 L 317.5 1945 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 967.5 1945 L 966.5 1947 L 967.5 1945 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 321.5 1948 L 322.5 1950 L 321.5 1948 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 963.5 1948 L 962.5 1950 L 963.5 1948 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 324.5 1950 L 325.5 1952 L 324.5 1950 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 960.5 1950 L 959.5 1952 L 960.5 1950 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 333.5 1956 L 334.5 1958 L 333.5 1956 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 951.5 1956 L 950.5 1958 L 951.5 1956 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 343.5 1962 L 344.5 1964 L 343.5 1962 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 941.5 1962 L 940.5 1964 L 941.5 1962 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 415.5 1990 L 418 1990.5 L 415.5 1991 L 415.5 1990 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 867.5 1990 L 870 1990.5 L 867.5 1991 L 867.5 1990 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 420.5 1991 L 423 1991.5 L 420.5 1992 L 420.5 1991 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 862.5 1991 L 865 1991.5 L 862.5 1992 L 862.5 1991 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 426.5 1992 L 429 1992.5 L 426.5 1993 L 426.5 1992 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 857.5 1992 L 860 1992.5 L 857.5 1993 L 857.5 1992 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 432.5 1993 L 435 1993.5 L 432.5 1994 L 432.5 1993 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 850.5 1993 L 853 1993.5 L 850.5 1994 L 850.5 1993 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 439.5 1994 L 444 1994.5 L 439.5 1995 L 439.5 1994 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 841.5 1994 L 846 1994.5 L 841.5 1995 L 841.5 1994 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 450.5 1995 L 458 1995.5 L 450.5 1996 L 450.5 1995 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 827.5 1995 L 836 1995.5 L 827.5 1996 L 827.5 1995 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 507.5 1996 L 508 2006.5 L 507 2006.5 L 507.5 1996 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 777.5 1996 L 778 2005.5 L 777 2005.5 L 777.5 1996 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 508.5 2010 L 509 2012.5 L 508 2012.5 L 508.5 2010 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 776.5 2010 L 777 2012.5 L 776 2012.5 L 776.5 2010 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 775.5 2015 L 776 2017.5 L 775 2017.5 L 775.5 2015 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 518.5 2039 L 519.5 2041 L 518.5 2039 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 766.5 2039 L 765.5 2041 L 766.5 2039 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 762.5 2045 L 761.5 2047 L 762.5 2045 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 524.5 2048 L 525.5 2050 L 524.5 2048 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 760.5 2048 L 758.5 2051 L 760.5 2048 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 527.5 2052 L 531.5 2057 L 527.5 2052 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 756.5 2053 L 752.5 2058 L 756.5 2053 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 747.5 2062 L 742.5 2068 L 747.5 2062 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 538.5 2063 L 542.5 2068 L 538.5 2063 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 545.5 2069 L 547.5 2072 L 545.5 2069 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 739.5 2069 L 737.5 2072 L 739.5 2069 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 549.5 2072 L 550.5 2074 L 549.5 2072 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 735.5 2072 L 734.5 2074 L 735.5 2072 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 558.5 2078 L 559.5 2080 L 558.5 2078 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 726.5 2078 L 725.5 2080 L 726.5 2078 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 606.5 2097 L 609 2097.5 L 606.5 2098 L 606.5 2097 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 676.5 2097 L 679 2097.5 L 676.5 2098 L 676.5 2097 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 612.5 2098 L 615 2098.5 L 612.5 2099 L 612.5 2098 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 670.5 2098 L 673 2098.5 L 670.5 2099 L 670.5 2098 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 618.5 2099 L 622 2099.5 L 618.5 2100 L 618.5 2099 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 663.5 2099 L 667 2099.5 L 663.5 2100 L 663.5 2099 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 627.5 2100 L 634 2100.5 L 627.5 2101 L 627.5 2100 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 651.5 2100 L 658 2100.5 L 651.5 2101 L 651.5 2100 Z"
          fill="currentColor"
          fillOpacity="0.7176471"
          stroke="currentColor"
          strokeOpacity="0.7176471"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 620.5 1 L 1013.5 1 L 1014.5 2 L 1025.5 2 L 1051.5 7 L 1076.5 16 Q 1108.3 30.7 1131 54.5 Q 1155.5 79.5 1169 115.5 L 1177 147.5 L 1178 165.5 L 1179 166.5 L 1179 181.5 L 1178 182.5 L 1178 193.5 L 1177 194.5 L 1175 211.5 L 1165 242.5 Q 1148.8 279.3 1120.5 304 L 1104 316 L 1106.5 320 Q 1120.9 329.1 1132 341.5 Q 1154.8 365.2 1168 398.5 L 1173 413.5 L 1177 431.5 L 1178 447.5 L 1179 448.5 L 1179 472.5 L 1178 473.5 L 1178 482.5 L 1177 483.5 L 1176 494.5 L 1171 513.5 L 1158 543.5 Q 1142.3 571.8 1118.5 592 L 1102 604.5 Q 1123.1 618.4 1139 637.5 Q 1157.8 659.7 1169 689.5 L 1177 720.5 L 1178 739.5 L 1179 740.5 L 1179 754.5 L 1178 755.5 L 1178 767.5 L 1177 768.5 L 1175 785.5 L 1164 818.5 Q 1148.3 852.3 1122.5 876 L 1104 890.5 L 1105.5 893 Q 1122.2 903.8 1135 918.5 Q 1156.6 941.9 1169 974.5 L 1175 995.5 L 1178 1012.5 L 1179 1045.5 L 1178 1046.5 L 1177 1062.5 L 1172 1083.5 Q 1166.6 1102.6 1157 1117.5 Q 1175.2 1138.3 1186 1166.5 L 1191 1181.5 L 1195 1200.5 L 1196 1218.5 L 1197 1219.5 L 1197 1236.5 L 1196 1237.5 L 1195 1255.5 L 1187 1286.5 L 1175 1312.5 L 1165 1329 L 1192.5 1334 L 1216.5 1344 Q 1237.6 1355.9 1253 1373.5 Q 1275.4 1397.6 1283 1436.5 Q 1281.5 1442 1284 1443.5 L 1284 1565.5 L 1283 1566.5 L 1281 1585.5 L 1277 1601.5 L 1269 1623.5 Q 1252.7 1660.2 1225.5 1686 Q 1198.4 1712.9 1159.5 1728 L 1137.5 1735 L 1116.5 1739 L 1070 1741 L 1069 1767.5 L 1068 1768.5 L 1068 1776.5 L 1064 1798.5 L 1050 1841.5 Q 1026.1 1895.6 984.5 1932 Q 946 1967 890.5 1985 L 871.5 1990 L 849.5 1994 L 841.5 1994 L 840.5 1995 L 827.5 1995 L 826.5 1996 L 777 1996 L 777 2009.5 L 771 2030.5 Q 762.6 2049.1 748.5 2062 Q 728.1 2081.6 698.5 2092 L 680.5 2097 L 663.5 2099 L 662.5 2100 L 634.5 2101 L 633.5 2100 L 622.5 2100 L 621.5 2099 L 604.5 2097 L 578.5 2089 Q 550.9 2077.6 532 2057.5 Q 519.2 2044.3 512 2025.5 L 508 2009.5 L 508 1996 L 458.5 1996 L 457.5 1995 L 435.5 1994 L 413.5 1990 L 382.5 1981 Q 319.5 1957 279 1910.5 Q 248.8 1877.2 231 1831.5 L 223 1806.5 L 219 1788.5 L 217 1769.5 L 216 1768.5 L 215 1740 L 178.5 1740 L 177.5 1739 L 169.5 1739 L 147.5 1735 L 125.5 1728 Q 82.7 1711.3 54 1680.5 Q 20.7 1646.8 6 1594.5 L 2 1574.5 L 1 1549.5 L 0 1548.5 L 0 1457.5 L 1 1456.5 L 1 1442.5 L 4 1426.5 L 11 1406.5 Q 23.6 1378.6 45.5 1360 Q 59.2 1348.2 76.5 1340 L 92.5 1334 L 107 1331 Q 93.8 1311.3 86 1285.5 L 80 1254.5 L 80 1231.5 Q 77.5 1230 79 1224.5 L 80 1223.5 L 81 1202.5 L 84 1187.5 L 94 1158.5 Q 109.3 1125.3 134.5 1102 L 149 1091 L 147.5 1088 L 126 1069.5 Q 102.1 1044.9 89 1009.5 L 81 978.5 L 80 961.5 L 79 960.5 L 79 941.5 L 80 940.5 L 80 930.5 L 84 908.5 L 96 875.5 Q 112.5 842 139.5 819 L 156 806.5 Q 137.1 793.4 122 776.5 Q 101.8 754.2 90 723.5 L 84 704.5 L 81 689.5 L 79 658.5 L 80 657.5 L 81 636.5 L 84 621.5 L 94 592.5 Q 109.8 557.8 136.5 534 L 154 521 L 151.5 517 Q 138.3 508.7 128 497.5 Q 103.7 473.3 90 438.5 L 84 419.5 L 81 404.5 L 80 387.5 L 79 386.5 L 79 367.5 L 80 366.5 L 80 356.5 L 81 355.5 L 82 343.5 L 90 315.5 Q 98 294 111 277.5 L 111 274.5 Q 94.4 253.6 86 224.5 L 80 194.5 L 79 170.5 L 80 169.5 L 80 156.5 L 81 155.5 L 81 148.5 L 83 138.5 Q 87.3 118.8 95 102.5 Q 112.1 67.1 140.5 43 Q 159.3 26.8 183.5 16 L 213.5 6 L 230.5 3 L 239.5 3 L 240.5 2 L 619.5 2 L 620.5 1 Z M 1003 70 L 1002 71 L 986 72 L 970 76 L 955 81 L 944 83 L 929 88 L 918 90 L 903 95 L 892 97 L 877 102 L 866 104 L 851 109 L 840 111 L 684 154 L 673 156 L 658 161 L 647 163 L 632 168 L 621 170 L 606 175 L 595 177 L 580 182 L 569 184 L 554 189 L 543 191 L 528 196 L 517 198 L 502 203 L 491 205 L 476 210 L 465 212 L 450 217 L 439 219 L 424 224 L 413 226 L 398 231 L 387 233 L 372 238 L 361 240 L 346 245 L 224 277 Q 199 285 183 300 Q 156 323 149 365 L 149 390 L 153 408 Q 161 431 176 448 Q 191 464 213 473 L 232 479 L 245 480 L 246 481 L 260 481 L 278 477 L 293 472 L 304 470 L 434 434 L 445 432 L 460 427 L 601 390 L 616 385 L 627 383 L 642 378 L 653 376 L 668 371 L 679 369 L 694 364 L 705 362 L 720 357 L 731 355 L 746 350 L 757 348 L 939 298 L 966 291 L 976 290 L 1014 279 L 1025 277 L 1039 273 L 1055 266 L 1075 252 Q 1088 240 1097 224 L 1105 205 L 1109 186 L 1109 164 L 1106 148 Q 1099 125 1086 109 Q 1071 91 1050 80 L 1026 72 L 1003 70 Z M 279 71 L 278 72 L 240 72 L 229 74 Q 203 81 186 96 Q 171 108 162 125 L 152 149 L 149 166 L 149 185 L 150 186 L 151 197 L 159 220 L 165 228 L 190 215 L 212 208 L 223 206 L 238 201 L 249 199 L 264 194 L 275 192 L 290 187 L 301 185 L 316 180 L 327 178 L 342 173 L 353 171 L 368 166 L 379 164 L 394 159 L 405 157 L 420 152 L 431 150 L 446 145 L 457 143 L 472 138 L 483 136 L 498 131 L 509 129 L 513 127 L 535 122 L 539 120 L 561 115 L 565 113 L 587 108 L 719 72 L 279 71 Z M 1000 356 L 970 363 L 944 371 L 933 373 L 918 378 L 907 380 L 892 385 L 881 387 L 866 392 L 855 394 L 840 399 L 829 401 L 814 406 L 803 408 L 788 413 L 777 415 L 762 420 L 751 422 L 736 427 L 725 429 L 710 434 L 699 436 L 684 441 L 673 443 L 658 448 L 647 450 L 632 455 L 621 457 L 606 462 L 595 464 L 580 469 L 569 471 L 554 476 L 543 478 L 539 480 L 413 513 L 398 518 L 387 520 L 372 525 L 361 527 L 346 532 L 335 534 L 320 539 L 309 541 L 305 543 L 288 547 L 283 547 L 227 562 Q 200 569 183 586 Q 166 602 156 625 L 151 641 L 150 653 L 149 654 L 149 673 L 153 693 Q 160 714 173 730 Q 187 746 207 756 L 225 763 L 239 766 L 249 766 L 250 767 L 267 766 L 278 764 L 293 759 L 304 757 L 475 710 L 486 708 L 501 703 L 512 701 L 527 696 L 538 694 L 553 689 L 564 687 L 590 679 L 601 677 L 616 672 L 627 670 L 642 665 L 653 663 L 668 658 L 679 656 L 694 651 L 705 649 L 720 644 L 731 642 L 746 637 L 757 635 L 772 630 L 783 628 L 798 623 L 809 621 L 824 616 L 835 614 L 850 609 L 861 607 L 876 602 L 887 600 L 902 595 L 1028 562 L 1044 557 L 1060 549 L 1075 538 Q 1102 515 1109 473 L 1109 448 L 1106 433 Q 1099 407 1083 391 Q 1067 373 1044 363 L 1022 357 L 1000 356 Z M 998 644 L 969 650 L 954 655 L 943 657 L 928 662 L 917 664 L 902 669 L 765 705 L 761 707 L 750 709 L 735 714 L 724 716 L 709 721 L 568 758 L 553 763 L 542 765 L 527 770 L 516 772 L 501 777 L 490 779 L 475 784 L 464 786 L 449 791 L 438 793 L 423 798 L 412 800 L 397 805 L 386 807 L 371 812 L 360 814 L 345 819 L 334 821 L 319 826 L 308 828 L 293 833 L 282 835 L 267 840 L 256 842 L 241 847 L 230 849 Q 203 856 185 872 Q 157 895 149 939 L 149 963 L 153 982 Q 160 1002 172 1017 Q 187 1034 209 1045 L 233 1053 L 251 1054 L 252 1055 L 254 1054 L 265 1054 L 273 1052 L 277 1050 L 418 1013 L 433 1008 L 444 1006 L 459 1001 L 470 999 L 485 994 L 496 992 L 511 987 L 522 985 L 537 980 L 548 978 L 563 973 L 574 971 L 589 966 L 600 964 L 615 959 L 626 957 L 641 952 L 652 950 L 667 945 L 678 943 L 693 938 L 704 936 L 719 931 L 730 929 L 745 924 L 756 922 L 771 917 L 782 915 L 797 910 L 808 908 L 823 903 L 834 901 L 849 896 L 860 894 L 875 889 L 886 887 L 901 882 L 912 880 L 927 875 L 938 873 L 953 868 L 979 863 L 1035 848 L 1058 838 L 1079 822 L 1092 806 L 1102 787 L 1107 771 L 1108 760 L 1109 759 L 1109 737 L 1104 715 Q 1096 691 1080 676 Q 1064 659 1041 650 L 1022 645 L 998 644 Z M 997 930 L 880 961 L 876 963 L 865 965 L 850 970 L 839 972 L 824 977 L 813 979 L 798 984 L 787 986 L 772 991 L 761 993 L 746 998 L 735 1000 L 720 1005 L 709 1007 L 694 1012 L 683 1014 L 668 1019 L 657 1021 L 642 1026 L 631 1028 L 616 1033 L 605 1035 L 590 1040 L 579 1042 L 564 1047 L 553 1049 L 538 1054 L 527 1056 L 512 1061 L 501 1063 L 449 1078 L 438 1080 L 423 1085 L 412 1087 L 397 1092 L 386 1094 L 371 1099 L 360 1101 L 345 1106 L 334 1108 L 319 1113 L 292 1120 L 282 1121 L 226 1136 Q 200 1143 184 1159 Q 167 1173 158 1195 L 151 1217 L 150 1233 L 149 1234 L 151 1250 L 156 1267 Q 164 1285 176 1299 Q 195 1319 226 1329 L 310 1329 L 318 1327 L 396 1305 L 407 1303 L 422 1298 L 433 1296 L 448 1291 L 459 1289 L 474 1284 L 485 1282 L 500 1277 L 511 1275 L 526 1270 L 537 1268 L 552 1263 L 563 1261 L 578 1256 L 589 1254 L 604 1249 L 615 1247 L 630 1242 L 641 1240 L 656 1235 L 667 1233 L 682 1228 L 693 1226 L 708 1221 L 719 1219 L 734 1214 L 745 1212 L 760 1207 L 771 1205 L 823 1190 L 834 1188 L 849 1183 L 860 1181 L 875 1176 L 886 1174 L 901 1169 L 912 1167 L 927 1162 L 1034 1134 Q 1059 1126 1077 1110 Q 1102 1087 1109 1047 L 1109 1022 L 1106 1007 Q 1099 982 1084 966 Q 1069 948 1047 938 L 1023 931 L 997 930 Z M 1111 1172 Q 1088 1190 1057 1200 L 583 1327 L 582 1329 L 1047 1329 Q 1072 1323 1090 1308 Q 1107 1294 1117 1274 L 1123 1259 L 1127 1240 L 1127 1217 Q 1125 1215 1126 1210 Q 1121 1188 1111 1172 Z M 130 1421 L 117 1424 L 106 1431 L 96 1445 L 93 1457 L 93 1552 L 94 1553 L 94 1561 Q 99 1592 117 1612 Q 139 1640 183 1647 L 256 1647 L 257 1646 L 1029 1646 L 1030 1647 L 1103 1647 Q 1104 1645 1109 1646 L 1132 1639 L 1156 1624 Q 1174 1609 1184 1586 L 1190 1567 L 1191 1552 L 1192 1551 L 1192 1457 L 1189 1445 L 1183 1435 L 1169 1424 L 1156 1421 L 130 1421 Z M 308 1716 L 308 1755 L 314 1787 Q 326 1825 351 1852 Q 373 1876 406 1890 L 433 1899 L 449 1902 L 459 1902 L 460 1903 L 591 1903 L 603 1899 L 619 1896 L 628 1896 L 629 1895 L 657 1895 L 658 1896 L 667 1896 L 687 1900 L 695 1903 L 826 1903 L 827 1902 L 843 1901 Q 895 1890 927 1859 Q 951 1836 965 1804 L 974 1775 L 976 1764 L 976 1756 L 977 1755 L 977 1717 L 977 1716 L 308 1716 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'FluorescentLamp')

export default icon
